import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { map, mapTo, switchMap } from "rxjs/operators";
import { ContactService } from "../../portal/contact-api/services/contact.service";
import * as ContactActions from "./contact.actions";

@Injectable()
export class ContactEffects {
  initializeAction$;
  purchaseContactAction$;
    constructor(
        private actions: Actions,
        private contactService: ContactService,
    ) {
      this.initializeAction$ = createEffect(() => this.actions.pipe(
        ofType(ContactActions.InitializeAction),
        switchMap(action => this.contactService.loadContact({ id: action.contactId })),
        map(contact => ContactActions.MergeStateAction({ newState: { currentContact: contact } })),
    ));

    this.purchaseContactAction$ = createEffect(() => this.actions.pipe(
        ofType(ContactActions.PurchaseContactAction),
        switchMap(action => this.contactService.purchaseContact({ id: action.contactId }).pipe(mapTo(action))),
        switchMap(action => this.contactService.loadContact({ id: action.contactId })),
        map(contact => ContactActions.MergeStateAction({ newState: { currentContact: contact } })),
    ));
    }
}
